import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { fetchOrganization } from '@common/resources/Organization/actions';
import { fetchService, clearService } from '@resources/Service/actions';
import { fetchSubmodulesByModuleCode } from '@resources/Submodule/actions';
import { Box, Container, View, Title } from '@common/components';
import { Affix, Menu, Typography } from 'antd';

const ServiceInfo = ({
	service,
	submodules,
	fetchService,
	fetchSubmodulesByModuleCode,
	organization,
	history,
	match,
}) => {
	const { serviceId, submoduleCode } = match?.params || {};
	const [current, setCurrent] = useState(submoduleCode || 'details');

	useEffect(() => {
		const fetchData = async () => {
			await fetchService(serviceId);
			await fetchSubmodulesByModuleCode('service');
		};

		fetchData();
	}, [fetchService]);

	const handleClick = (e) => {
		if (e.key === 'details') {
			history.push(
				organization.alias
					? `/${organization.alias}/services/${serviceId}/details`
					: `/services/${serviceId}/details`
			);
		} else {
			history.push(
				organization.alias
					? `/${organization.alias}/services/${serviceId}/details/${e.key}`
					: `/services/${serviceId}/details/${e.key}`
			);
		}

		setCurrent(e.key);
	};

	return (
		<View>
			<Container>
				<Box py={50}>
					<Title fontSize={100} lineHeight={1} mb={10}>
						{service.title}
					</Title>
					<Typography.Title level={2}>Service</Typography.Title>
				</Box>
				<Affix offsetTop={100}>
					<Menu
						onClick={handleClick}
						mode="horizontal"
						selectedKeys={[current]}>
						<Menu.Item key="details">Details</Menu.Item>
						{submodules &&
							submodules.map((submodule) => (
								<Menu.Item key={submodule.url}>
									{submodule.title}
								</Menu.Item>
							))}
					</Menu>
				</Affix>
			</Container>
		</View>
	);
};

const mapStateToProps = ({ service, submodules, organization }) => {
	return {
		service,
		submodules,
		organization,
	};
};

export default connect(mapStateToProps, {
	fetchService,
	fetchSubmodulesByModuleCode,
	fetchOrganization,
	clearService,
})(ServiceInfo);
